
export const View = {
  name: 'view',
  props: ['user', 'account', 'biz', 'srvs', 'prds', 'cats', 'csts', 'modals']
}

export const Translatable = {
  name: 'translatable',

  data() {
    return {
      locale: this.$i18n.locale || 'en'
    }
  },

  methods: {
    translate() {
      this.$i18n.locale  = this.locale
      if ( !this.account ) localStorage.setItem( 'locale', this.locale )
    }
  }
}

export const Animatable = {
  name: 'animatable',

  data() {
    return {
      show: false
    }
  },

  beforeRouteLeave (to, from, next) {
    this.show = !this.show
    setTimeout( () => next(), 360 )
  },

  mounted() {
    this.show = !this.show
  }
}
